document.addEventListener('DOMContentLoaded', function() {
  if (sessionStorage.getItem('authenticated')) {
    window.location.href = '/pages/sci-home';
  }
});

const boxMsgErr = document.querySelector('[data-err-msg]');
  
const handlePassword = () => {
  const passwordInput = document.getElementById('sci-password');

  const hashedPassword = 'dcddf1ef3dad105ca96ea9d0c9116469981e62982f3d35995d87fd9db9a3071c';

  crypto.subtle.digest('SHA-256', new TextEncoder().encode(passwordInput.value))
      .then(hash => {
        const hashArray = Array.from(new Uint8Array(hash));
        const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
        if(hashHex === hashedPassword) {
          sessionStorage.setItem('authenticated', 'true');
          window.location.href = '/pages/sci-home';
        } else {
          boxMsgErr.style.display = 'block';
         }
       })
      .catch(err => {
        console.error('Error hashing:', err);
      });
}

const handleCloseAlert = () => {
  boxMsgErr.style.display = 'none';
}

document.querySelector('.btn-sci').addEventListener('click', handlePassword)
document.querySelector('[data-err-btn]').addEventListener('click', handleCloseAlert)